<template>
  <div class="DarkWhite">
    <v-card
      :loading="filterLoading"
      class="mb-5"
    >
    <template slot="progress">
        <v-progress-linear color="header" indeterminate></v-progress-linear>
    </template>
        <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
            v-model="FundID"
            item-text="FundCode"
            item-value="FundID"
            :items="funds"
            hide-details
            color="header"
            label="Filter by Funds"
          >
          </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
            v-model="ClassificationID"
            item-text="ClassificationDescription"
            item-value="ClassificationID"
            :items="classifications"
            hide-details
            color="header"
            label="Filter by Classification"
          >
          </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-menu
              dense
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              :return-value.sync="DateRange"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-combobox
                  dense
                  v-model="DateRange"
                  label="Date Range"
                  color="header"
                  v-bind="attrs"
                  v-on="on"
                  class="mt-5"
                  hide-details
                  clearable
                >
                </v-combobox>
              </template>
              <v-date-picker
                v-model="DateRange"
                no-title
                scrollable
                range
                color="header"
              >
                <v-spacer></v-spacer>
                <v-btn text color="header" @click="menu1 = false">
                  Cancel
                </v-btn>
                <v-btn
                  class="white--text"
                  color="header"
                  @click="$refs.menu1.save(DateRange)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
            v-model="UserID"
            item-text="name"
            item-value="UserID"
            :items="users"
            hide-details
            color="header"
            label="Filter by User"
          >
          </v-autocomplete>
          </v-col>
        </v-row>
        </v-card-text>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="itemList"
      :options.sync="options"
      :server-items-length="totalCount"
      :loading="loading"
      :footer-props="footerProps"
      class="elevation-1 pt-2"
    >
    <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            v-model="searchText"
            append-icon="mdi-magnify"
            placeholder="Search Item here..."
            color="green darken-2"
            class="mr-2 mt-2"
            dense
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <vue-json-to-csv 
          :json-data="itemListForCSV"
          :labels="{ 
            StockPropertyNo: { title: 'Stock/Property No' },
            ItemName: { title: 'ItemName' },
            ItemDescription: { title: 'ItemDescription' },
            Qty: { title: 'Qty' },
            UnitCost: { title: 'UnitCost' },
            EndUser: { title: 'End User' },
            EUL: { title: 'Date Acquired' },
            EULYear: { title: 'EUL (Year)' },
            RemainingYears: { title: 'Years Remaining' },
            }"
          csv-title="Inventory">
            <v-btn
              outlined
              color="green darken-2"
              dark
              :loading="loadingCSV"
            >
              <v-icon class="mr-1">mdi-microsoft-excel</v-icon>
              CSV
            </v-btn>
          </vue-json-to-csv>
        </v-toolbar>
      </template>
      <template v-slot:[`item.StockPropertyNo`]="{ item }">
        {{ item.StockPropertyNo }}
      </template>
      <template v-slot:[`item.ItemName`]="{ item }">
        {{item.ItemName}}
      </template>
      <!-- <template v-slot:[`item.ItemDescription`]="{ item }">
        {{item.ItemDescription}}
      </template> -->
      <template v-slot:[`item.Qty`]="{ item }">
        {{formatQty(item.Qty)}}
      </template>
      <template v-slot:[`item.UnitCost`]="{ item }">
        <span class="text-no-wrap">₱ {{formatPrice(item.UnitCost)}}</span>
      </template>
      <template v-slot:[`item.Amount`]="{ item }">
        <span class="text-no-wrap">₱ {{formatPrice(item.Amount)}}</span>
      </template>
      <template v-slot:[`item.EndUser`]="{ item }">
        {{getUserDetail(item.UserID)}}
      </template>
      <template v-slot:[`item.EUL`]="{ item }">
        <span class="text-no-wrap">{{ formatDate(item.EUL) }}</span>
      </template>
      <template v-slot:[`item.EULYear`]="{ item }">
        <span v-if="item.EULYear">{{ item.EULYear }}</span>
        <span v-else class="text-no-wrap"><i>NO EUL</i></span>
      </template>
      <template v-slot:[`item.RemainingYears`]="{ item }">
        <span class="font-weight-bold" v-if="item.RemainingYears != null">
          <span v-if="item.RemainingYears <= 0" style="color: red;">
            {{ item.RemainingYears }}
          </span>
          <span v-else style="color: green;">
            {{ item.RemainingYears }}
          </span>
        </span>
        <span v-else class="text-no-wrap"><i>NO EUL</i></span>
      </template>
      <template v-slot:[`item.DateCreated`]="{ item }">
        {{ formatDate(item.DateCreated) }}
      </template>
      <template v-slot:[`item.Other_Actions`]="{ item }">
        <span class="text-no-wrap">
        <v-btn
          color="red darken-2"
          dark
          outlined
          elevation="2"
          x-small
          @click="endOfLife(item)"
          v-if="parseFloat(item.UnitCost) < 5000"
        >
          Revert EEUL
        </v-btn>
        </span>
      </template>
      <template v-slot:[`item.Actions`]="{ item }">
        <span class="text-no-wrap">
        <!-- <v-btn
          color="green darken-2"
          class="mr-2"
          dark
          outlined
          elevation="2"
          x-small
          @click="printSC(item)"
          v-if="item.ICSPARType == 1 && item.StockTypeID == 1"
        >
          Stock Card
        </v-btn>
        <v-btn
          color="green darken-2"
          class="mr-2"
          dark
          outlined
          elevation="2"
          x-small
          @click="printSEPC(item)"
          v-if="item.ICSPARType == 1 && item.StockTypeID == 2"
        >
          SEP Card
        </v-btn>
        <v-btn
          color="green darken-2"
          class="mr-2"
          dark
          outlined
          elevation="2"
          x-small
          @click="printPC(item)"
          v-if="item.ICSPARType == 2"
        >
          Property Card
        </v-btn> -->
        <v-btn
          color="blue darken-2"
          dark
          outlined
          elevation="2"
          x-small
          @click="view(item)"
        >
          View
        </v-btn>
        </span>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogEndOfLife" max-width="700px">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <div class="mx-6">
          Are you sure you want to <b>REVERT</b> this item from the <b>Expiration of Estimated Useful Life</b>?
        </div>
        <div class="mx-6 mt-6">
          <i><strong>NOTE: </strong> This action cannot be undone. Please check the item details if accurate for the action.</i>
        </div>
        <div class="mx-6 mt-6" v-if="eolData.ItemName">
          <table border="1" class="eol-style">
            <tr>
              <td style="width: 25%;" valign="top"><strong>Stock/Property No: </strong></td>
              <td>{{eolData.StockPropertyNo}}</td>
            </tr>
            <tr>
              <td valign="top"><strong>Item Name: </strong></td>
              <td>{{eolData.ItemName}}</td>
            </tr>
            <tr>
              <td valign="top"><strong>Item Description: </strong></td>
              <td>{{eolData.ItemDescription}}</td>
            </tr>
            <tr>
              <td valign="top"><strong>Quantity: </strong></td>
              <td>{{formatQty(eolData.Qty)}}</td>
            </tr>
            <tr>
              <td valign="top"><strong>UnitCost: </strong></td>
              <td>₱ {{formatPrice(eolData.UnitCost)}}</td>
            </tr>
            <tr>
              <td valign="top"><strong>ICS Code: </strong></td>
              <td>{{eolData.Code}}</td>
            </tr>
            <tr>
              <td valign="top"><strong>End User: </strong></td>
              <td>{{getUserDetail(eolData.UserID)}}</td>
            </tr>
            <tr>
              <td valign="top"><strong>Date Acquired: </strong></td>
              <td>{{formatDate(eolData.EUL)}}</td>
            </tr>
            <tr>
              <td valign="top"><strong>Remaining Year/s: </strong></td>
              <td>
                <span class="font-weight-bold" v-if="eolData.RemainingYears != null">
                <span v-if="eolData.RemainingYears <= 0" style="color: red;">
                  {{ eolData.RemainingYears }}
                </span>
                <span v-else style="color: green;">
                  {{ eolData.RemainingYears }}
                </span>
              </span>
              <span v-else class="text-no-wrap"><i>NO EUL</i></span>
              </td>
            </tr>
          </table>
        </div>
        <v-card-actions class="mt-5">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-2" outlined @click="dialogEndOfLife = false">Cancel</v-btn>
          <v-btn color="red darken-2 white--text" :loading="eolLoading" @click="confirmRevertEndOfLife()"><v-icon class="mr-1">mdi-close-circle</v-icon>REVERT EXPIRATION</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ICSModal :icsData="icsData" />
    <PARModal :parData="parData" />
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  components: {
    ICSModal: () => import("./ViewICS.vue"),
    PARModal: () => import("./ViewPAR.vue"),
  },
  props: {
    fiscalYear: null
  },
  data: () => ({
    searchText: "",
    searchTimeout: null,
    footerProps: { "items-per-page-options": [5, 10, 20, 50, 100, 500] },
    totalCount: 0,
    loading: true,
    menu1: null,
    options: {},
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Saved!",
      message: "",
      top: 10,
    },
    isLoading: false,
    itemList: [],
    headers: [
      {
          text: 'Stock/Property No.',
          align: 'start',
          sortable: false,
          value: 'StockPropertyNo',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Item Name',
          align: 'start',
          sortable: false,
          value: 'ItemName',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Item Description',
          align: 'start',
          sortable: false,
          value: 'ItemDescription',
          width: 320,
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Qty',
          align: 'center',
          sortable: false,
          value: 'Qty',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Unit Cost',
          align: 'end',
          sortable: false,
          value: 'UnitCost',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        //  {
        //   text: 'Amount',
        //   align: 'end',
        //   sortable: false,
        //   value: 'Amount',
        //   class: "green darken-2 white--text text-caption font-weight-bold"
        // },
        {
          text: 'ICS CODE',
          align: 'center',
          sortable: false,
          value: 'Code',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'End User/s',
          align: 'center',
          sortable: false,
          value: 'EndUser',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Date Acquired',
          align: 'center',
          sortable: false,
          value: 'EUL',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'EUL',
          align: 'center',
          sortable: false,
          value: 'EULYear',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Years Remaining',
          align: 'center',
          sortable: false,
          value: 'RemainingYears',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        { text: '', value: 'Other_Actions', align: 'center', sortable: false, class: "green darken-2 white--text text-caption font-weight-bold" },
        { text: 'Actions', value: 'Actions', align: 'center', sortable: false, class: "green darken-2 white--text text-caption font-weight-bold" },
      ],
      funds: [],
      filterLoading: false,
      FundID: 0,
      ClassificationID: 0,
      classifications: [],
      users: [],
      users2: [],
      UserID: 0,
      DateRange: null,
      icsData: [],
      parData: [],
      loadingCSV: false,
      itemListForCSV: [],
      eolData: {},
      dialogEndOfLife: false,
      eolLoading: false,
  }),
  watch: {
    searchText: function () {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.initialize();
      }, 600);
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    fiscalYear: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    FundID: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    ClassificationID: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    UserID: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    DateRange: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {
    this.getBudgetTypeAndOffice();
    this.getClassification();
    this.eventHub.$on("closeViewICS", () => {
      this.initialize();
    });
    this.eventHub.$on("closeViewPAR", () => {
      this.initialize();
    });
  },
  beforeDestroy() {
    this.eventHub.$off("closeViewICS");
    this.eventHub.$off("closeViewPAR");
  },
  methods: {
    initialize() {
      this.loading = true;
      this.loadingCSV = true;
      if(this.fiscalYear != null){
      let data = new FormData();
      if (this.options.page) {
        data.append("page", this.options.page);
        data.append("itemsPerPage", this.options.itemsPerPage);
      } else {
        data.append("page", 1);
        data.append("itemsPerPage", 10);
      }
      data.append("tab", this.tab);
      data.append("searchText", this.searchText);
      data.append("FiscalYearID", this.fiscalYear);
      data.append("FundID", this.FundID);
      data.append("ClassificationID", this.ClassificationID);
      data.append("UserID", this.UserID);
      data.append("DateRange", this.DateRange ? this.DateRange : '');
      data.append("ItemType", this.ItemType);
      data.append("ItemYear", this.ItemYear);
      data.append("Admin", 1);
      this.axiosCall("/ris/getInventoryWithEULExpired", "POST", data).then((res) => {
        this.loading = false;
        this.loadingCSV = false;
        this.itemList = res.data.data.result;
        this.itemListForCSV = res.data.data.result;
        this.users2 = res.data.data.users;
        this.itemListForCSV.forEach(item => {
          item.EndUser = this.getUserDetail(item.UserID);
          // item.yearsRemaining = this.getRemainingYears(item.EUL, item.EULYear);
        });
        this.totalCount = res.data.data.total;
        if (this.totalCount <= 10) {
          this.options.page = 1;
        }
      });
      }
    },
    view(item){
      if(item.ICSPARType == 1){
        this.icsData = item.details
      }
      else if(item.ICSPARType == 2){
        this.parData = item.details
      }
    },
    getClassification() {
      this.axiosCall("/getClassification", "GET").then((res) => {
        this.classifications = this.prepend({ClassificationID: 0, ClassificationDescription: 'All'},res.data.data.classification);
      });
    },
    getBudgetTypeAndOffice() {
      this.axiosCall(
              '/getOfficeAndOthersForCreateUpdate',
              'GET'
          )
          .then((res) => {
              // this.office = res.data.data.office;
              this.funds = this.prepend({FundID: 0, FundCode: 'All'},res.data.data.fund);
              // this.specificfundsourceList = res.data.data.specificfundsource;
              // this.purposeList = res.data.data.purpose;
              // this.allotmentList = res.data.data.allotmenttype;
              // this.deliveryunit = res.data.data.deliveryunit;
              this.users = this.prepend({UserID: 0, name: 'All'},res.data.data.users);
          })
		},
    prepend(value, array) {
    var newArray = array.slice();
    newArray.unshift(value);
    return newArray;
    },
    getUserDetail(UserID){
      let user = UserID.toString();
      let f_user  = user.split(',')[0];
      let result = this.users2.find((user) => user.UserID == f_user)
      if(result){
        return this.titleCase(result.name) + (user.split(',').length > 1 ? ' and ' + (user.split(',').length - 1) + ' other/s' : '')
      }
      else{
        return 'no user'
      }
    },
    endOfLife(data) {
      this.dialogEndOfLife = true;
      this.eolData = data;
    },
    confirmRevertEndOfLife(){
      if(this.eolData.ICSPARItemID){
      this.eolLoading = true;
      let data = new FormData();
        data.append("ICSItemID", this.eolData.ICSPARItemID);
        data.append("Qty", this.eolData.Qty);
        this.axiosCall("/ics/expired/revert", "POST", data).then((res) => {
        if(res.data.status){
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.message = "Item " + (this.eolData.ItemName || '').toUpperCase() + " [" + this.eolData.StockPropertyNo + "] was successful set to reverted from Expiration of Estimated Useful Life.";
          this.fadeAwayMessage.header = "System Message";
          this.dialogEndOfLife = false;
          this.eolData = {};
        }
        else{
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.message = "Something went wrong!";
          this.fadeAwayMessage.header = "System Message";
        }
        this.eolLoading = false;
        this.initialize();
        });
      }
    }
  },
};
</script>
<style scoped>
.eol-style {
  border-collapse: collapse;
}
.eol-style tr td {
  padding: 5px;
}
</style>